import { memo } from "react";
import { FaAward, FaExternalLinkAlt } from "react-icons/fa";
import { GrCertificate } from "react-icons/gr";

function renderContent({ lab, certificate, useIcon, hideLabName, hideCertiNumber }) {
    if (useIcon) return lab !== "NON" ? <FaAward /> : "";
    if (!hideLabName && !hideCertiNumber) {
        return `${lab !== "NON" ? `${lab}:` : ""}${
            lab !== "NON" ? `${certificate}` : "NON-CERTIFIED"
        }`;
    }
    if (!hideLabName) return lab !== "NON" ? lab : "";
    if (!hideCertiNumber) return lab !== "NON" ? certificate : "NON-CERTIFIED";
    return "";
}

function CertificateLink({
    lab,
    certificate,
    Certificate_link,
    useIcon = false,
    className = "text-xs text-wahchan-primary",
    withExternalLinkIcon = false,
    hideLabName = false,
    hideCertiNumber = false,
    GrCerti = false,
}) {
    return (
        <a
            href={Certificate_link || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
        >
            {GrCerti && <GrCertificate className="mr-1 text-base inline" />}
            {renderContent({ lab, certificate, useIcon, hideLabName, hideCertiNumber })}
            {withExternalLinkIcon && lab !== "NON" ? (
                <FaExternalLinkAlt className="ml-1 inline" />
            ) : null}
        </a>
    );
}

export default memo(CertificateLink);
